import { useMemo } from 'react';
import { useAuthStore } from '@/stores/auth/auth-store';
import { useEditorStore } from '@/stores/editor/editor-store';
import type { Project } from '@/types';
import {
  createAICommandPermissionGuard,
  type AICommandPermissionGuard,
} from '@/services/ai/agentCommandPermissions';

export function useAICommandPermissions(project: Project | null | undefined): AICommandPermissionGuard {
  const user = useAuthStore((state) => state.user);

  return useMemo(
    () => createAICommandPermissionGuard(project, user, {
      resolveComponentById: (id) => useEditorStore.getState().getComponent(id),
    }),
    [project, user],
  );
}
